// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"75db5f0a","158":"e39e478f","364":"0358ae00","410":"861d704e","453":"4deb57a6","475":"3342602c","947":"bd5ba6c9"}[chunkId] + ".chunk.js";
};